module.exports = __webpack_public_path__ + "yeni fatih atlas mutfak.jpg?b09da7c8c1c4ce4fd8d760dba5c8fee4";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fatih atlas mutfak.jpg
// module id = 374
// module chunks = 0